export * from './ValuePropositionItem'
